import { render, staticRenderFns } from "./moneyList.vue?vue&type=template&id=5cd0afb5&scoped=true&"
import script from "./moneyList.vue?vue&type=script&lang=js&"
export * from "./moneyList.vue?vue&type=script&lang=js&"
import style0 from "./moneyList.vue?vue&type=style&index=0&id=5cd0afb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd0afb5",
  null
  
)

export default component.exports